<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}室开放实验情况</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室编号`">
          <el-input v-model="formInline.training_no" clearable  :placeholder="`请输入${$store.state.themeTitle}室编号`"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_name" clearable filterable :placeholder="`请选择所属${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column prop="training_name"  fixed :label="`${$store.state.themeTitle}室名称`"  min-width="160" >
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="120">
        </custom-table-column>
        <custom-table-column prop="experiment_number_on_campus" label="开放实验个数（校内）" width="120">
        </custom-table-column>
        <custom-table-column prop="experiment_number_off_campus" label="开放实验个数（校外）" width="120">
        </custom-table-column>
        <custom-table-column prop="person_number_on_campus" label="开放实验人数（校内）" width="120">
        </custom-table-column>
        <custom-table-column prop="person_number_off_campus" label="开放实验人数（校外）" width="120">
        </custom-table-column>
        <custom-table-column prop="experiment_hours_on_campus" label="开放实验人时数（校内）" width="120">
        </custom-table-column>
        <custom-table-column prop="experiment_hours_off_campus" label="开放实验人时数（校外）" width="120">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row,['display_order', 'school_id'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"  :title="title" :visible.sync="centerDialogVisible" width="706px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" >
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开放实验个数（校内）" prop="experiment_number_on_campus">
          <el-input v-model.number="ruleForm.experiment_number_on_campus" placeholder="请输入开放实验个数（校内）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开放实验个数（校外）" prop="experiment_number_off_campus">
          <el-input v-model.number="ruleForm.experiment_number_off_campus" placeholder="请输入开放实验个数（校外" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开放实验人数（校内）" prop="person_number_on_campus">
          <el-input v-model.number="ruleForm.person_number_on_campus" placeholder="请输入开放实验人数（校内）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开放实验人数（校外）" prop="person_number_off_campus">
          <el-input v-model.number="ruleForm.person_number_off_campus" placeholder="请输入开放实验人数（校外）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开放实验人时数（校内）" prop="experiment_hours_on_campus">
          <el-input v-model.number="ruleForm.experiment_hours_on_campus" placeholder="请输入开放实验人时数（校内）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="开放实验人时数（校外）" prop="experiment_hours_off_campus">
          <el-input v-model.number="ruleForm.experiment_hours_off_campus" placeholder="请输入开实验人时数（校外）" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"  title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    
    return {
      classRooms: [],
      institutes: [],
      formInline: {
        training_no:'',
        training_name: '',
      },
      users:[],
      levell: [1,2],
      loading: false,
      ruleForm: {
        training_room_id: '',
        experiment_number_on_campus: 0,
        experiment_number_off_campus: 0,
        person_number_on_campus: 0,
        person_number_off_campus: 0,
        experiment_hours_on_campus: 0,
        experiment_hours_off_campus: 0,
      },
      rules: {
        training_room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        experiment_number_on_campus: [{ type: 'number', message: '必须为数字值' },],
        experiment_number_off_campus: [{ type: 'number', message: '必须为数字值' },],
        person_number_on_campus: [{ type: 'number', message: '必须为数字值' },],
        person_number_off_campus: [{ type: 'number', message: '必须为数字值' },],
        experiment_hours_on_campus: [{ type: 'number', message: '必须为数字值' },],
        experiment_hours_off_campus: [{ type: 'number', message: '必须为数字值' },],
      },
      type: 'add',
      tableName: '实训日志',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    // this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTarinMent');
    // 
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleTeacherChange(val){
      this.ruleForm.teacher = this.$until.getLabelName(this.users, 'number', 'name', val);
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(apply_id, apply_status) {
      let str = '通过';
      if (apply_status == 2) {
        str = '拒绝';
      }
      this.$confirm(`此操作将${str}该实训计划, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.applyStatus(apply_id, apply_status, str);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async applyStatus(plan_id, apply_status, str) {
      let params = { plan_id, apply_status };
      let res = await this.$api.update.applyPlanStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `${str}成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/training/room/opening/destroy/${params.id}`, 'get', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/room/opening/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/training/room/opening/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    handleQuery() {
      this.beforeQueryByKey("query_structure_1","query_structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/training/room/opening/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
